import { links } from '@/localization';

import ApiReferenceSvg from './static-svgs/api-reference.svg';
import BlogSvg from './static-svgs/blog.svg';
import DocsSvg from './static-svgs/docs.svg';
import ExamplesSvg from './static-svgs/examples.svg';
import ModelLibrarySvg from './static-svgs/model-library.svg';
import { LeanSection } from './types';

const mapSectionToLink = {
  [LeanSection.DOCS]: links.basetenDocs,
  [LeanSection.EXAMPLES]: links.basetenDocsExamples,
  [LeanSection.MODEL_LIBRARY]: links.basetenModelLibrary,
  [LeanSection.API_REFERENCE]: links.basetenDocsReference,
  [LeanSection.BLOG]: links.basetenBlog,
};

const mapSectionToTitle = {
  [LeanSection.DOCS]: 'Docs',
  [LeanSection.EXAMPLES]: 'Examples',
  [LeanSection.MODEL_LIBRARY]: 'Model library',
  [LeanSection.API_REFERENCE]: 'API reference',
  [LeanSection.BLOG]: 'Blog',
};

const mapSectionToStaticSvg = {
  [LeanSection.DOCS]: DocsSvg,
  [LeanSection.EXAMPLES]: ExamplesSvg,
  [LeanSection.MODEL_LIBRARY]: ModelLibrarySvg,
  [LeanSection.API_REFERENCE]: ApiReferenceSvg,
  [LeanSection.BLOG]: BlogSvg,
};

function loadAnimation(section: LeanSection, cb: (animationData: unknown) => void) {
  switch (section) {
    // we have to explicitly mention all the paths because the build process doesn't support dynamic imports
    case LeanSection.DOCS:
      import('@/components/Animations/Learn/docs.json').then((module) => {
        cb(module.default);
      });
      break;
    case LeanSection.EXAMPLES:
      import('@/components/Animations/Learn/examples.json').then((module) => {
        cb(module.default);
      });
      break;
    case LeanSection.MODEL_LIBRARY:
      import('@/components/Animations/Learn/model-library.json').then((module) => {
        cb(module.default);
      });
      break;
    case LeanSection.API_REFERENCE:
      import('@/components/Animations/Learn/api-reference.json').then((module) => {
        cb(module.default);
      });
      break;
    case LeanSection.BLOG:
      import('@/components/Animations/Learn/blog.json').then((module) => {
        cb(module.default);
      });
      break;
  }
}

export { mapSectionToLink, mapSectionToTitle, mapSectionToStaticSvg, loadAnimation };
